<template>
  <section class="callbar">
    <div class="callbar-button" @click="toggleRoadside">
      <img src="../assets/icons/truck.png" alt="tow truck icon" />
      <p>Roadside</p>
    </div>
    <div class="callbar-button" @click="onstar">
      <img src="../assets/icons/onstar.png" alt="onstar icon" />
      <p>Call OnStar</p>
    </div>
    <div class="callbar-button" @click="toggleSos">
      <img class="sos" src="../assets/icons/sos.png" alt="sos icon" />
      <p>Call SOS</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Callbar",
  props: {
    onstar: Function,
    close: Function,
    toggleSos: Function,
    toggleRoadside: Function
  },
  data() {
    return {
      string: "hello",
      showAlert: false
    };
  },
  methods: {
    nav(dest) {
      this.$router.push({ path: `${dest}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.callbar {
  position: absolute;
  right: 2%;
  left: 2%;
  bottom: 70px;
  background-color: #17192b;
  border-radius: 80px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  padding: 0.5rem;

  @media only screen and (max-width: 900px) {
    right: 13px;
  }

  &-button {
    img {
      width: 50px;
      height: auto;
    }
    p {
      margin: 0;
      font-size: 0.75rem;
    }
    @media only screen and (min-height: 900px) {
      p {
        font-size: 1.25rem;
      }
    }
  }

  &-button:last-of-type {
    margin-top: 2px;

    .sos {
      margin-bottom: 5px;
      width: 45px;
    }
  }

  &-button:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>
